
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import { sharedState } from '../../../../framework/state';
import { getResourcesNew } from '../../../../framework/client/resource';

import EmailField from '../../../../framework/fields/EmailField.vue';

import { NotificationRecipient } from '../../../../../common/application/model/NotificationRecipient';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { SmartFleetTask } from '../../../../../common/application/model/SmartFleetTask';
import { postSendSmartFleetTaskEmail } from '../../../client/email_client';

@Component({
    components: { EmailField, ValidationObserver },
})
export default class ConfirmSendReminderModal extends Vue {
    @Prop(Object) readonly smartFleetTask!: SmartFleetTask;

    shared = sharedState;
    local = {
        loading: false,
        sending: false,
        notificationRecipients: [] as NotificationRecipient[],
        oneTimeEmail: '',
        smartFleetTask: {} as SmartFleetTask,
    };

    async mounted() {
        this.local.smartFleetTask = this.smartFleetTask;
        await this.loadAsyncData();
    }

    async sendReminder(): Promise<void> {
        this.local.sending = true;

        try {
            if (this.local.oneTimeEmail.length) {
                await postSendSmartFleetTaskEmail(
                    this.local.smartFleetTask.customerId,
                    this.local.smartFleetTask.vehicleContractId,
                    this.local.oneTimeEmail,
                    this.local.smartFleetTask.taskType,
                    this.shared.context.locale as 'fi' | 'en',
                );
            } else if (!this.local.notificationRecipients.length) {
                this.local.sending = false;
                this.$emit('close');
                return;
            } else {
                for (const notificationRecipient of this.local.notificationRecipients) {
                    if (!notificationRecipient.email) {
                        continue;
                    }

                    await postSendSmartFleetTaskEmail(
                        this.local.smartFleetTask.customerId,
                        this.local.smartFleetTask.vehicleContractId,
                        notificationRecipient.email,
                        this.local.smartFleetTask.taskType,
                        notificationRecipient.locale,
                    );
                }
            }

            this.local.sending = false;

            this.$emit('close');
        } catch (e) {
            this.local.sending = false;
            console.error(e);
        }
    }

    get notificationRecipientList(): string {
        let list = '';

        this.local.notificationRecipients.forEach((recipient, i) => {
            if (i === 0) {
                list += recipient.email;
            } else {
                list += `, ${recipient.email}`;
            }
        });

        return list;
    }

    private async loadAsyncData(): Promise<void> {
        this.local.loading = true;

        const params = new Map<string, string>([
            ['customerId', this.local.smartFleetTask.customerId],
            ['notificationType', this.local.smartFleetTask.taskType],
        ]);

        const notificationRecipients = await getResourcesNew<NotificationRecipient>(
            ApplicationResource.NOTIFICATION_RECIPIENT,
            -1,
            params,
        );

        const vehicleSpecificRecipient = notificationRecipients.find(
            ({ vehicleContractId }) => this.local.smartFleetTask.vehicleContractId === vehicleContractId,
        );

        if (vehicleSpecificRecipient) {
            this.local.notificationRecipients = [vehicleSpecificRecipient];
        }

        if (!vehicleSpecificRecipient) {
            this.local.notificationRecipients = notificationRecipients.filter(
                (recipient) => recipient.vehicleContractId === null && recipient.email !== null,
            );
        }

        this.local.loading = false;
    }
}
